import React, { forwardRef, ReactNode } from 'react';

import { padding, useClassnames } from '@lumapps/classnames';
import { Size } from '@lumapps/lumx/react';

import './index.scss';

export interface ChatMessageBubbleProps {
    className?: string;
    /** Message content */
    children: ReactNode;
    /** Type of message to adapt the bubble's style */
    type?: 'sent' | 'received';
}

const CLASSNAME = 'lumx-chat-message-bubble';

/**
 * Component to display a message in a chat "bubble" display
 * Style depends on the type of message (sent or received)
 * @family Chat
 * @param ChatMessageBubbleProps
 * @returns ChatMessageBubble
 */
export const ChatMessageBubble = forwardRef<HTMLDivElement, ChatMessageBubbleProps>(
    ({ children, className, type = 'sent' }, ref) => {
        const { block } = useClassnames(CLASSNAME);

        return (
            <div ref={ref} className={block({ [type]: true }, [padding('all', Size.big), className])}>
                {children}
            </div>
        );
    },
);
